d<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 pa-4 gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm6>
                <h3>Zprávy</h3>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum }}</td>
                  <td>{{ props.item.odesilatel }}</td>
                  <td>{{ props.item.predmet }}</td>
                  <td>{{ props.item.stav }}</td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      dialogDetail: false,
      headers: [
        { text: 'Datum a čas', value: 'datum' },
        { text: 'Odesílatel', value: 'odesilatel' },
        { text: 'Předmět', value: 'predmet' },
        { text: 'Stav', value: 'stav' }
      ],
      items: [
        {
          datum: '29. 1. 2019 14:00',
          odesilatel: 'Igor Smrťák',
          predmet: 'Test',
          stav: 'Doručeno',
        },
        {
          datum: '31. 1. 2019 14:00',
          odesilatel: 'Václav Rejcha',
          predmet: 'Předmět',
          stav: 'Přečteno',
        }
      ]
    }
  },
  watch: {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Zpravy/Zpravy.vue